const getTranslationsQuery = (type: string, language: string) => {
  return `
  query getTranslationsMetaobject @inContext(country: ${window.Shopify?.country}, language: ${language}) {
   metaobjects(first: 1,type: "${type}") {
        edges {
            node {
                fields {
                    key
                    value
                }
            }
        }
    }
}`;
};

export default getTranslationsQuery;
